export default {
  svgData: [
    {
      id: "slide3easel1",
      name: "Easel1",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/cvl/detours/high-falls-road-detour-1.jpg"
      ],
      label: "slide3easel1label"
    },
    {
      id: "slide3easel2",
      name: "Easel2",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/cvl/detours/pea-ridge-detour-1.jpg"
      ],
      label: "slide3easel2label"
    },
    {
      id: "slide3avatar1"
    },
    {
      id: "slide3bubble1"
    }
  ],
  slideTitle: "Potential Detours",
  aboutText: `
    <p class="text-justify help">
    For projects involving the closure of a roadway and/or bridge during construction and resulting 
    in an off-site detour, Georgia DOT will present the potential detour to the public so that specific 
    concerns can be identified and addressed.
    </p>
    <p class="text-justify help">
    To accommodate the new I-75 Commercial Vehicle Lanes, the project’s design requires the replacement of 
    two existing bridge overpasses over I-75: <b>High Falls Road</b> and <b>Pea Ridge Road</b>. The existing bridges will 
    need to be demolished and rebuilt in their current location. Georgia DOT has developed potential detour 
    routes for motorists during the closure and construction of each bridge. Advance notice will be provided 
    to the public before a bridge closes to traffic. All detours will be coordinated with local governments, 
    schools, and first responders.
    </p>
    <p class="text-justify help">
    Once your tour of the Potential Detours station is complete, we invite you to visit the next station by 
    clicking on the right arrow or selecting your station of choice from the sidebar on the right.
    </p> 
  `,
  helpText: `
  <p class="text-justify help">
  This virtual meeting is also serving as the project’s Public Detour Open House (PDOH). To accommodate 
  the proposed I-75 Commercial Vehicle Lanes, the project’s design anticipates multiple bridge replacements, 
  and detours will be needed during bridge construction in some locations. Boards displayed in this space 
  show the potential detours for the following two bridges over I-75: 
  </p>
  <ul class="text-justify help">
  <li>
  <b>High Falls Road</b>
  </li>
  <br>
  <li>
  <b>Pea Ridge Road</b>
  </li>
  </ul>
  <br>
  <p class="text-justify help">
  Click each easel to review the potential detours for these two bridges.
  </p>
  <p class="text-justify help">
  <b>Click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i> to learn about the specific 
  station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i> to see this message again after you close it out</b>.
  </p>
  `
};
